import session from 'express-session';
import React, { createRef, useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import HtmlEditer from '../../../../Common/Component/HtmlEditer';
import { checkSession } from '../../../../Common/Utils/SsoSession';

function WriteMode(props) {
  const [Session, setSession] = useState({});
  const [SendData, setSendData] = useState({ "num": "", "id": "", "name": "", "title": "", "contents": "" });
  const [Category, setCategory] = useState(['ALL', 'NoData']);
  const [CategoryValue, setCategoryValue] = useState(props.Data === undefined ? 'ALL' : props.Data.NOTICE_CATEGORY);
  const [IsPublicValue, setIsPublicValue] = useState(props.Data === undefined ? '공개' : props.Data.Public === 1 ? '공개' : '비공개');
  useEffect(() => { // 폼로드와 비슷한 개념
    getCategory();
    CreateSession();
    if (props.Data != undefined) {
      setSendData({ ...SendData, title: props.Data.NOTICE_TITLE, Category: props.Data.NOTICE_CATEGORY, contents: props.Data.NOTICE_CONTENTS, PUBLIC: props.Data.PUBLIC });
    }
  }, []);
  const CreateSession = () => {
    checkSession()
      .then((msg) => { setSession(msg) })
      .catch(err => alert(err + '오류'));
  }

  const Link = () => {
    ReactDOM.render(<div />, document.getElementById('Board_Contents'));
    document.getElementById('Board_Contents').setAttribute('class', 'Contents_Deactive');
  };

  const DataSubmit = (SendData) => {
    if (props.Data === undefined)
      fetch('/request/InsertDeveloperBoard', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(SendData)
      }
      ).then(props.Refrash)
        .then(Link).catch(err => alert('DataInsert' + err));
    else
      fetch('/request/UpdateDeveloperBoard', {
        method: 'POST',
        mode: 'cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(SendData)
      }
      ).then(props.Refrash).then(Link).catch(err => alert('UpdateItem' + err));
  }
  const getCategory = () => {
    fetch('/request/DeveloperCategoryList', {
      method: 'POST',
      mode: 'cors',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(SendData)
    }
    ).then(res => res.json())
      .then((msg) => {
        setCategory(msg);
        setCategoryValue(props.Data === undefined ? msg[0].NOTICE_CATEGORY : props.Data.NOTICE_CATEGORY);
        setSendData({ ...SendData, Category: msg[0].NOTICE_CATEGORY });
      })
      .catch(err => alert('DesignCategoryList' + err));
  }
  return (
    <div>
         <div style={{padding:'30px'}}>
      <section style={{height:'38px',display:'flex'}}>
                <input placeholder='아이디' style={{width:'33.33%',borderRadius:'5px',borderWidth:'1px', padding:'0.5rem' ,borderColor:'silver'}} type='text' value={Session.UserId == undefined ? SendData.name : Session.Name} onChange={(ev) => setSendData({ ...SendData, name: ev.target.value })}></input>
                <select placeholder='카테고리' style = {{width:'33.33%', padding:'0.5rem' ,borderColor:'silver'}}value={CategoryValue} defaultValue={CategoryValue} onChange={(e) => setCategoryValue(e.target.value)} type='text'>
                  {Category.map((Data, i) => (<option value={Data.NOTICE_CATEGORY} key={i}>{Data.NOTICE_CATEGORY}</option>))}
                </select>
                <select style={{ width:'33.33%',padding:'0.5rem' ,borderColor:'silver'}} placeholder='공개범위' value={IsPublicValue} onChange={(ev) => setIsPublicValue(ev.target.value)} type='text'>
                  <option>공개</option>
                  <option>비공개</option>
                </select>
          </section>
          <div id='EditerBox' style={{ minHeight: '300px', marginTop:'30px' }}>
          <HtmlEditer Submit={DataSubmit} setData={setSendData} Data={props.Data} SelectCategory={CategoryValue} Public={IsPublicValue} Session={Session}/>
        </div>
      </div>
    </div>
  )
}


export default WriteMode;